import * as React from 'react';
// import logo from 'assets/images/ebullion-logo.svg';
import logo from 'assets/images/coin-bazzar1.png';
import { Navbar, Nav, NavDropdown, Badge } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import api from 'api/client';
import Zendesk from 'react-zendesk';
import { useEffect, useState } from 'react';
import { userStore } from '../../store/UserStore';
import ArticleView from '../../../src/pages/articles/index';
import { useLocation } from 'react-router-dom';
import { clearSessionData } from 'utils';
import TopBands from './TopBands';
import './style.css';
interface PropTypes {
  isLinkShow: boolean;
}

const Header: React.FC<PropTypes> = ({ isLinkShow }) => {
  const history = useHistory();
  // const navigate = useNavigate();
  const location = useLocation();
  const [user, customerId, customer] = userStore((state: any) => [
    state.user,
    state.customerId,
    state.customer,
  ]);
  const [isDocShow, setDocShow] = useState(false);
  const [url, setUrl] = useState(null);

  const setting = {
    color: {
      theme: '#DDA838',
    },
    launcher: {
      chatLabel: {
        'en-US': 'Need Help',
      },
    },
    contactForm: {
      ticketForms: [{ id: 426353 }],
      subject: true,
      fields: [{ id: 'description', prefill: { '*': '' } }],
    },
    webWidget: {
      chat: {
        suppress: false,
        notifications: {
          mobile: {
            disable: true,
          },
        },
      },
      talk: {
        nickname: 'Sales Support',
        suppress: false,
        title: {
          '*': 'Talk with us!',
        },
      },
      // answerBot: {
      //   suppress: false,
      //   title: {
      //     '*': 'Chat with us!'
      //   },
      //   contactOnlyAfterQuery: true,
      //   search: {
      //     labels: ['I would like help.']
      //   },
      //   avatar: {
      //     url: 'https://youravatarurl.com/image.png',
      //     name: {
      //       '*': 'Company logo'
      //     }
      //   }
      // }
    },
  };

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  const signout = () => {
    clearSessionData();
    history.push('/signin');
  };

  const goTo = (url: string) => {
    // window.location.href = url;
    window.open(
      url,
      '_blank' // <- This is what makes it open in a new window.
    );
  };

  const setClass = (route: any) => {
    return url === route ? ' active' : '';
  };

  return (
    <>
      <TopBands /> 
      <Navbar
        bg='white'
        className='shadow-sm px-5 py-3 sticky-top-nav'
        expand='lg'
      >
        <Navbar.Brand href='/dashboard'>
          <img src={logo} alt='' />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='me-auto border-bottom-0' variant='tabs'>
            {isLinkShow ? (
              // <Nav className="me-auto border-bottom-0" variant="tabs">
              <>
                <Nav.Link className={setClass('/dashboard')}>
                  <Link
                    to='/dashboard'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Dashboard
                  </Link>
                </Nav.Link>

                <Nav.Link className={setClass('/buy-sell')}>
                  <Link
                    to='/buy-sell'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Buy/Sell
                  </Link>
                </Nav.Link>

                <Nav.Link href='/sip' className={setClass('/sip')}>
                  <Link
                    to='/sip'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    SIP
                  </Link>
                </Nav.Link>
                <Nav.Link href='/daily-savings' className={setClass('/daily-savings')}>
                  <Link
                    to='/daily-savings'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Daily savings
                  </Link>
                </Nav.Link>
                {customer?.customerCategory === 'UNREGISTERED' && (
                  <Nav.Link href='/gift' className={setClass('/gift')}>
                    <Link
                      to='/gift'
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      Gift
                    </Link>
                  </Nav.Link>
                )}
                <Nav.Link className={setClass('/passbook')}>
                  <Link
                    to='/passbook'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Passbook
                  </Link>
                </Nav.Link>
                {/* <Nav.Link className={setClass('/wallet')}>
                  <Link
                    to='/wallet'
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Wallet
                  </Link>
                </Nav.Link> */}
                <NavDropdown title="Charts" style={{ textDecoration: 'none', color: 'gray' }} id='basic-nav-dropdown-1' className={setClass('/price-charts')}>
                  <NavDropdown.Item
                    style={{ textDecoration: 'none', 
                      backgroundColor: window.location.pathname === '/price-charts' ? 'gray' : 'transparent',
                      color: window.location.pathname === '/price-charts' ? 'white' : 'gray',
                     }}
                    onClick={() => {
                      history.push('/price-charts');
                    }}
                  >
                    Price Charts
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    style={{ textDecoration: 'none',
                      backgroundColor: window.location.pathname === '/gold-silver' ? 'gray' : 'transparent',
                      color: window.location.pathname === '/gold-silver' ? 'white' : 'gray',
                     }}
                    onClick={() => {
                      history.push('/gold-silver');
                    }}
                  >
                  Gold / Silver Ratio
                  </NavDropdown.Item>
                </NavDropdown>

              </>
            ) : (
              // </Nav>
              ''
            )}
            <NavDropdown
              title={user?.displayName || ''}
              id='basic-nav-dropdown'
              className='me-auto border-bottom-0'
            >
              <NavDropdown.Item
                onClick={() => {
                  setDocShow(true);
                }}
              >
                Articles
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() =>
                  goTo(
                    'https://ebullion.in/terms-and-conditions/privacypolicy.html'
                  )
                }
              >
                Privacy Policy
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() =>
                  goTo('https://ebullion.in/terms-and-conditions/terms.html')
                }
              >
                T&C
              </NavDropdown.Item>
              <NavDropdown.Divider />
              {customerId && (
                <NavDropdown.Item onClick={() => history.push('/profile')}>
                  My Profile
                </NavDropdown.Item>
              )}
              {/* <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item> */}
              {customerId && <NavDropdown.Divider />}
              <NavDropdown.Item onClick={() => signout()}>
                Sign Out
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {/* <Zendesk
        defer
        zendeskKey='443d9587-9b1a-4712-bd96-dadac1ca7971'
        {...setting}
        onLoaded={() => null}
      /> */}
      <ArticleView
        handleModal={() => {
          setDocShow(false);
        }}
        isShow={isDocShow}
      />
    </>
  );
};
export default Header;